import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { CardholderApiModelStub } from '../api-models/stubs/CardholderApiModel.stub'

export const mockGetCardholdersResponse = (
  cardholderStubs = CardholderApiModelStub.buildList(1)
) => {
  return http.get(
    `/api/v3/pay/cardholders/`,
    () => {
      return HttpResponse.json(getResponseObject(cardholderStubs), {
        status: 200,
      })
    },
    { once: true }
  )
}

export const mockGetCardholdersError = () => {
  return http.get(
    `/api/v3/pay/cardholders/`,
    () => {
      return HttpResponse.json({}, { status: 401 })
    },
    { once: true }
  )
}
